import { useMemo } from "react";
import { AxnAdminAvailableUserProperty } from "@idw-types/data/axn-admin-available-user-property";
import { AxnAdminUserPropertyCategory } from "@idw-types/data/reference-data/generic";
import { AxnAdminUserOrganizationProperty } from "@idw-types/data/axn-admin-user";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { CardContainer } from "@containers/common/card-container/card-container";
import { ContentPageBodyDescription } from "@containers/common/content-page-body-description/content-page-body-description";
import { OrganizationPermissionContainer } from "./organization-permission-container/organization-permission-container";
import commonStyles from "../organization-user-details-permissions-panel-tab.less";

type OrganizationPermissionsContainerProps = {
    isDisabled: boolean;
    userId: string;
    organizationId: string;
    axnAdminUserPropertyCategories: Array<AxnAdminUserPropertyCategory>;
    axnAdminUserOrganizationProperties: Array<AxnAdminUserOrganizationProperty>;
    axnAdminAvailableUserOrganizationProperties: Array<AxnAdminAvailableUserProperty>;
    addOrganizationProperties: (orgProperties: Array<AxnAdminUserOrganizationProperty>) => void;
    removeOrganizationProperties: (orgProperties: Array<AxnAdminUserOrganizationProperty>) => void;
};

export const OrganizationPermissionsContainer = (props: OrganizationPermissionsContainerProps) => {
    const {
        isDisabled,
        userId,
        organizationId,
        axnAdminUserPropertyCategories,
        axnAdminUserOrganizationProperties,
        axnAdminAvailableUserOrganizationProperties,
        addOrganizationProperties,
        removeOrganizationProperties
    } = props;

    const categorizedOrgProperties = useMemo(() => {
        const categoryPropertyArrays = axnAdminUserPropertyCategories.map(category => {
            const categoryProperties = axnAdminAvailableUserOrganizationProperties.filter(property => property.categoryID === category.id);

            return {
                category,
                categoryProperties
            };
        });

        return categoryPropertyArrays.filter(cpa => cpa.categoryProperties.length > 0);
    }, [
        axnAdminUserPropertyCategories,
        axnAdminAvailableUserOrganizationProperties
    ]);

    return (
        <div>
            {categorizedOrgProperties.map(categoryObj => (
                <CardContainer key={`org-user-property-category-${categoryObj.category.id}`}>
                    <ContentPageHeader title={categoryObj.category.name} />
                    <ContentPageBody isMaxWidth={true}>
                        <ContentPageBodyDescription descriptionText={categoryObj.category.description} />
                        <div className={commonStyles.multiPermissionContainer}>
                            {categoryObj.categoryProperties.map(property => (
                                <OrganizationPermissionContainer
                                    key={`organization-permission-container-${property.shortName}`}
                                    axnAdminAvailableUserOrganizationProperty={property}
                                    userId={userId}
                                    axnAdminUserOrganizationProperties={axnAdminUserOrganizationProperties}
                                    isDisabled={isDisabled}
                                    organizationId={organizationId}
                                    addOrganizationProperties={addOrganizationProperties}
                                    removeOrganizationProperties={removeOrganizationProperties}
                                />
                            ))}
                        </div>
                    </ContentPageBody>
                </CardContainer>
            ))}
        </div>
    );
};